import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {},
  getters,
});
const modulesContext = require.context('./modules', false, /\.js$/);
modulesContext.keys().forEach((modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const module = modulesContext(modulePath);
  store.registerModule(moduleName, module.default);
});
export default store;
